"use client";
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const InterviewBottleneckSection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <Box
      sx={{
        py: { xs: 5, sm: 6, md: 8 },
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "45% 55%" },
            gap: { xs: 3, md: 5, lg: 6 },
          }}
        >
          {/* Left - Label + Heading */}
          <Box sx={{ textAlign: isArabic ? "right" : "left" }}>
            <Typography
              sx={{
                fontSize: { xs: "11px", sm: "12px" },
                fontWeight: 600,
                color: "#7A2BF5",
                textTransform: "uppercase",
                letterSpacing: "1px",
                fontFamily: "var(--font-outfit)",
                mb: { xs: 1.5, sm: 2 },
              }}
            >
              {t("interviewBottleneck.label")}
            </Typography>

            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "26px", sm: "30px", md: "34px", lg: "38px" },
                fontWeight: 700,
                lineHeight: 1.25,
                color: "#14122B",
                fontFamily: "var(--font-plusjakarta)",
              }}
            >
              {t("interviewBottleneck.heading")}
            </Typography>
          </Box>

          {/* Right - Divider + Description */}
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: { xs: 2, sm: 3 },
            }}
          >
            <Box
              sx={{
                width: "3px",
                minHeight: "100%",
                alignSelf: "stretch",
                bgcolor: "#7A2BF5",
                borderRadius: "2px",
                flexShrink: 0,
              }}
            />
            <Typography
              sx={{
                fontSize: { xs: "14px", sm: "15px", md: "16px" },
                color: "#3D3D52",
                lineHeight: 1.8,
                fontWeight: 400,
                fontFamily: "var(--font-outfit)",
                textAlign: isArabic ? "right" : "left",
                maxWidth:'70%'
              }}
            >
              {t("interviewBottleneck.description")}
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default InterviewBottleneckSection;